import { render, staticRenderFns } from "./PDFTemplate.vue?vue&type=template&id=6eb5faca"
import script from "./PDFTemplate.vue?vue&type=script&lang=js"
export * from "./PDFTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports